import Nullstack from 'nullstack';
export default function IconBrandYahoo({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-yahoo",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "6",
    x2: "8",
    y2: "6"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "18",
    x2: "14",
    y2: "18"
  }), "   ", Nullstack.element("path", {
    d: "M4.5 6l5.5 7v5"
  }), "   ", Nullstack.element("path", {
    d: "M10 13l6 -5"
  }), "   ", Nullstack.element("line", {
    x1: "12.5",
    y1: "8",
    x2: "17.5",
    y2: "8"
  }), "   ", Nullstack.element("line", {
    x1: "20",
    y1: "11",
    x2: "20",
    y2: "15"
  }), "   ", Nullstack.element("line", {
    x1: "20",
    y1: "18",
    x2: "20",
    y2: "18.01"
  }), " ");
}